// JS for the loading animation and slider on collection page
$('.custom-collection__List .shop_by_category').hide();
$('.custom-collection__List .title-wrapper-with-link').hide();
$('.custom-collection__List .swiper-button-next').hide();
$('.custom-collection__List .swiper-button-prev').hide();

var swipercl = null;

$(window).on('load', function() {

  var loadingOverlay = $(".loading-overlay-collection");

  function initSwipercl() {

    // Prevent multiple initialization
    if (swipercl) {
      return;
    }

    swipercl = new Swiper(".custom-collection__List .shop_by_category", {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      spaceBetween: 0,
      speed: 1000,
      loop: false,
      freeMode: {
      enabled: true,
    },

      mousewheel: {
        forceToAxis: true
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      on: {
        init: function() {

          loadingOverlay.fadeOut(500, function() {

            document.querySelector('.custom-collection__List .shop_by_category').style.display = "block";
            document.querySelector('.custom-collection__List .title-wrapper-with-link').style.display = "block";

            $('.custom-collection__List .swiper-button-next').fadeIn(500);
            $('.custom-collection__List .swiper-button-prev').fadeIn(500);

          });

        },
      },
    });
  }

  initSwipercl();

  // Update swiper on resize instead of reinitializing
  $(window).on('resize', function() {
    if (swipercl) {
      swipercl.update();
    }
  });

  if($('.custom-collection__List .shop_by_category .swiper-button-next').hasClass('swiper-button-disabled')){
    $('.custom-collection__List .shop_by_category .swiper-button-next')
      .removeClass('swiper-button-disabled swiper-button-lock');
  }

});